import { CheckList, List } from '@intigral/shared/components/CheckList';
import styles from './upgrade.module.sass';
import cn from 'classnames';
import { FlexWrapper, ResponsiveImage, Skeleton } from '@intigral/shared';

interface UpgradeProps extends React.HTMLAttributes<HTMLDivElement> {
    logo?: string;
    picture?: string | { src: string; width: number }[];
    list?: List[];
    text?: string;
    button?: [LinkComponent: any, text: string];
    children?: React.ReactNode;
    isLoading?: boolean;
    variant: 'page' | 'modal' | 'ppv';
    id?: string;
}

export const Upgrade = ({
    logo,
    picture,
    list,
    text,
    button,
    children,
    isLoading,
    variant = 'page',
    className,
    id,
    ...props
}: UpgradeProps) => {
    const classes = cn(styles.upgrade, styles[variant], className);

    if (isLoading) {
        return (
            <div className={classes} style={{ width: '100%' }} {...props} id={id} data-test-id={id}>
                <div className={styles.title} style={{ alignItems: 'center' }}>
                    <Skeleton variant="circle" width={42} height={42} />
                    <Skeleton variant="text" height={24} width={72} />
                </div>
                <div>
                    <Skeleton variant="text" height={12} />
                    <Skeleton variant="text" height={12} />
                    <Skeleton variant="text" height={12} />
                    <Skeleton variant="text" height={12} />
                </div>
                {variant == 'page' ? (
                    <div className={styles.inner}>
                        <Skeleton variant="rounded" width={112} height={36} />
                        <Skeleton variant="text" height={24} />
                    </div>
                ) : (
                    <div className={styles.inner}>
                        <Skeleton variant="text" height={24} />
                        <FlexWrapper flexDirection="row" gap={{ default: '2x', md: '4x' }}>
                            <Skeleton variant="rounded" width="50%" height={36} />
                            <Skeleton variant="rounded" width="50%" height={36} />
                        </FlexWrapper>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div style={{ position: 'relative', overflow: 'hidden' }}>
            <div className={classes} {...props} data-test-id="upgrade-banner">
                {picture && (
                    <div className={styles.bg}>
                        <ResponsiveImage picture={picture} />
                    </div>
                )}
                {(logo || text) && (
                    <div className={styles.title}>
                        {logo && <img src={logo} alt="" />}
                        {text && <div className={styles.text}>{text}</div>}
                    </div>
                )}
                {list && <CheckList items={list} className={styles.list} />}
                {children && <div className={styles.inner}>{children}</div>}
            </div>
        </div>
    );
};
